var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"color":'orange darken-1',"text":""},on:{"click":function($event){$event.stopPropagation();return _vm.clearSearch.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-eraser icon-right-space"}),_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }